import React, { useContext } from 'react';
import Logo from './Logo';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  const { translations } = useContext(LanguageContext);
  return (
    <footer className="bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-300 pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="col-span-1 lg:col-span-1">
            <Logo size="md" textColor="text-gray-800 dark:text-white" className="mb-4" />
            <p className="text-sm mb-4">{translations['footer.phone'] || 'Phone #'} +234 810 757 4322</p>
            <p className="text-sm">23 Urban Dwell, FCDA, Abuja Nigeria</p>
          </div>
          
          <div>
            <h4 className="text-blue-900 dark:text-blue-100 font-semibold mb-4">{translations['footer.offerings']}</h4>
            <ul className="space-y-2">
              <li><Link to="/openshift-consultancy" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.openshiftConsultancy'] || 'OpenShift Consultancy'}</Link></li>
              <li><Link to="/monitoring-observability" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.monitoringObservability'] || 'Monitoring & Observability'}</Link></li>
              <li><Link to="/platform-re-engineering" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.platformReEngineering'] || 'Platform Re-Engineering'}</Link></li>
              <li><Link to="/advanced-kubernetes-services" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.advancedKubernetesServices'] || 'Advanced Kubernetes Services'}</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-blue-900 dark:text-blue-100 font-semibold mb-4">{translations['footer.kubernetesServices']}</h4>
            <ul className="space-y-2">
              <li><Link to="/service-mesh-istio" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.serviceMeshIstio'] || 'Service Mesh (Istio)'}</Link></li>
              <li><Link to="/open-telemetry-observability" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.openTelemetryObservability'] || 'OpenTelemetry & Observability'}</Link></li>
              <li><Link to="/kubernetes-platform-security" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.kubernetesPlatformSecurity'] || 'Kubernetes Platform Security'}</Link></li>
              <li><Link to="/advanced-kubernetes-networking" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.advancedKubernetesNetworking'] || 'Advanced Kubernetes Networking'}</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-blue-900 dark:text-blue-100 font-semibold mb-4">{translations['footer.learning']}</h4>
            <ul className="space-y-2">
              <li><Link to="/red-hat-certification-training" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.redHatCertificationTraining'] || 'Red Hat Certification Training & Enablement'}</Link></li>
              <li><Link to="/cloud-certification-training" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.cloudCertificationTraining'] || 'Cloud (AWS, Azure, GCP) Certification Training'}</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-blue-900 dark:text-blue-100 font-semibold mb-4">{translations['footer.company']}</h4>
            <ul className="space-y-2">
              <li><Link to="/faqs" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.faqs']}</Link></li>
              <li><Link to="/careers-and-jobs" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.careers']}</Link></li>
              <li><Link to="/contact" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.contact']}</Link></li>
              <li><Link to="/support" className="hover:text-blue-600 dark:hover:text-blue-400 transition">{translations['footer.support']}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 dark:border-gray-800 pt-8 text-sm text-center">
          <p>{translations['footer.copyright']}</p>
          <div className="mt-2 space-x-4">
            <Link to="/privacy-policy" className="hover:text-blue-600 dark:hover:text-blue-400">{translations['footer.privacy']}</Link>
            <Link to="/terms-of-use" className="hover:text-blue-600 dark:hover:text-blue-400">{translations['footer.terms']}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;